import _ from 'lodash';
import React from 'react';
import withAuth from './with-auth';

const forAuthenticatedOnly = Component =>
  withAuth(({ isAuthenticated, ...otherProps }) => {
    const props = _.omit(otherProps, ['currentUser', 'isBlocked', 'isOwner', 'dispatch', 'isPrivate', 'forPublicUser']);
    return isAuthenticated ? <Component {...props}/> : null;
  });

export default forAuthenticatedOnly;



// WEBPACK FOOTER //
// ./app/hoc/for-authenticated-only.js